import { render } from "./ProfileFriendCardSkeleton.vue?vue&type=template&id=31c55238&scoped=true"
import script from "./ProfileFriendCardSkeleton.vue?vue&type=script&lang=js"
export * from "./ProfileFriendCardSkeleton.vue?vue&type=script&lang=js"

import "./ProfileFriendCardSkeleton.vue?vue&type=style&index=0&id=31c55238&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31c55238"]])

export default __exports__